/**
 * useDocumentTitle Hook
 * Sets the browser document title for better history/tab identification
 * Issue #896: Page names in browser history
 */

import { useEffect } from 'react';

const BASE_TITLE = 'ORO move';

/**
 * Set document title with consistent suffix
 * @param title - Page-specific title (e.g., "Stoll Family Fitness", "Morning Run")
 * @param options - Optional config
 */
export function useDocumentTitle(
  title: string | undefined | null,
  options: { suffix?: boolean } = { suffix: true }
) {
  useEffect(() => {
    const previousTitle = document.title;
    const nextTitle = title ? (options.suffix ? `${title} | ${BASE_TITLE}` : title) : BASE_TITLE;
    document.title = nextTitle;

    // Restore previous title on unmount (for SPA navigation). When the
    // "previous" title is this page's OWN title, it came from the served HTML
    // (the marketing routes inject it server-side, #3515), not from a prior
    // page; restoring it would leave this page's title on the next route, so
    // fall back to the base title instead.
    return () => {
      document.title = previousTitle === nextTitle ? BASE_TITLE : previousTitle;
    };
  }, [title, options.suffix]);
}

export default useDocumentTitle;
